import * as actionTypes from "./actionTypes";

export const loadReviewTag = data => {
  return {
    type: actionTypes.LOAD_REVIEW_TAG,
    data
  };
};

export const loadReviewTagSuccess = data => {
  return {
    type: actionTypes.LOAD_REVIEW_TAG_SUCCESS,
    data
  };
};

export const loadReviewTagFail = () => {
  return {
    type: actionTypes.LOAD_REVIEW_TAG_FAIL
  };
};

export const loadRestaurantReview = (restaurantID, data, reviewID = null) => {
  return {
    type: actionTypes.LOAD_RESTAURANT_REVIEW,
    restaurantID,
    reviewID,
    data
  };
};

export const loadRestaurantReviewSuccess = data => {
  return {
    type: actionTypes.LOAD_RESTAURANT_REVIEW_SUCCESS,
    data
  };
};

export const loadRestaurantReviewFail = () => {
  return {
    type: actionTypes.LOAD_RESTAURANT_REVIEW_FAIL
  };
};

export const likedRestaurantReview =(data)=>{
  return {
    type: actionTypes.LIKED_RESTAURANT_REVIEW,
    data
  };
}
